import React, { useEffect, useRef, useState } from 'react';

const Products = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const products = [
    {
      name: 'Cloud ERP System Solution',
      category: 'Ascali Soft enterprise',
      description: 'Our fully managed ERP offers a comprehensive cloud-based ecosystem for multi-entity financial management. Available via web and mobile, it streamlines complex accounting, real-time reporting, and intercompany consolidations. Experience seamless automation and secure, centralized data control across all your business branches, ensuring your financial operations remain agile, compliant, and scalable in a digital-first world.',
      techStack: [

        'Sql Server',
        'C#',
        'MVC with Entity Framework',
        'React Js',
        'AWS',
        'Node.Js',
        'Flutter'

      ],
      features: [
        'Multi-Entity Consolidation',
        'Real-Time Accounting',
        'Automated Reconciliation',
        'Cross-Platform Access',
        'Fully Managed Infrastructure',
        'Multi-Currency & Tax Engine',
        'Role-Based Access Control'

      ],
      status: 'Live',
      image: '/api/placeholder/400/300',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      name: 'CRM',
      category: 'Ascali core CRM',
      description: 'Our fully managed Core CRM provides a centralized cloud hub for mastering customer relationships across web and mobile. Effortlessly track leads, automate sales workflows, and access deep pipeline analytics from anywhere. Designed for scalability, it ensures seamless team collaboration and personalized engagement, empowering your business to convert prospects into loyal partners with data-driven precision.',
      techStack: [
        'Sql Server',
        'C#',
        'MVC with Entity Framework',
        'React Js',
        'AWS',
        'Node.Js',
        'Flutter'

      ],
      features: [
        '360° Lead Tracking',
        'Automated Workflows',
        'Contact Management',
        'Real-Time Dashboards',
        'Forecasting Tools',
        'Mobility & Integration',
        'ERP Readiness',
        'Support Ticketing',
        'Task & Calendar Sync'

      ],
      status: 'Live',
      image: '/api/placeholder/400/300',
      color: 'from-purple-500 to-pink-500'
    },
    {
      name: 'HRM',
      category: 'Ascali HRM',
      description: 'Our fully managed HRM solution provides a robust, cloud-based platform for modern workforce management. Available on web and mobile, it automates payroll, attendance tracking, and performance evaluations seamlessly. Empower your HR team with centralized employee records, self-service portals, and advanced talent analytics, ensuring a compliant, engaged, and highly productive organization across every department and location.',
      techStack: [
        'Sql Server',
        'C#',
        'MVC with Entity Framework',
        'React Js',
        'AWS',
        'Node.Js',
        'Flutter'

      ],
      features: [
        'Centralized Employee Database',
        'Automated Onboarding & Offboarding',
        'Performance & Appraisals',
        'Precision Attendance',
        'Leave Management',
        'Integrated Payroll Engine',
        'Employee Self-Service',
        'Manager Dashboards',
        'Regulatory Compliance',
        'HR Analytics'


      ],
      status: 'Live',
      image: '/api/placeholder/400/300',
      color: 'from-green-500 to-teal-500'
    },
    {
      name: 'Restaurant and Café POS',
      category: 'Ascali Café POS',
      description: 'Our fully managed Restaurant and Cafe POS provide a high-speed, cloud-based solution for seamless dining operations. Available on web and mobile, it integrates table management, real-time inventory tracking, and split-billing effortlessly. Enhance guest experiences with integrated digital menus and kitchen display systems, ensuring your front-of-house and kitchen stay perfectly synced for maximum efficiency and growth.',
      techStack: [
        'Sql Server',
        'C#',
        'MVC with Entity Framework',
        'React Js',
        'AWS',
        'Node.Js',
        'Flutter'

      ],
      features: [
        'Smart Order Management',
        'Table & Floor Mapping',
        'KDS (Kitchen Display System)',
        'Multi-Mode Ordering',
        'Inventory & Menu Control',
        'Real-Time Ingredient Tracking',
        'Recipe Management',
        'Dynamic Menu Updates',
        'End-of-Day (EOD) Reporting'


      ],
      status: 'Live',
      image: '/api/placeholder/400/300',
      color: 'from-orange-500 to-red-500'
    },
    {
      name: 'E-Commerce platform',
      category: 'Ascali Ecommerce Application',
      description: 'Our fully managed Multi-vendor E-commerce platform offers a scalable, cloud-based marketplace for diverse sellers. Available via web and mobile, it features unified vendor dashboards, secure payment gateways, and automated commission tracking. Empower your business with advanced logistics integration, real-time inventory synchronization, and personalized buyer experiences, creating a seamless, high-growth digital storefront for global or local trade.',
      techStack: [
        'Sql Server',
        'C#',
        'MVC with Entity Framework',
        'React Js',
        'AWS',
        'Node.Js',
        'Flutter'

      ],
      features: [
        'Dedicated Vendor Dashboards',
        'Automated Commission Management',
        'Bulk Product Upload',
        'Intelligent Search & Filters',
        'Multi-Vendor Cart',
        'Real-Time Order Tracking',
        'Admin & Platform Control',
        'Vendor Approval Workflow',
        'Unified Payment Gateway',
        'Notifications',
        'Inventory Sync'


      ],
      status: 'Live',
      image: '/api/placeholder/400/300',
      color: 'from-indigo-500 to-purple-500'
    },
    {
      name: 'Van Sale Pos application',
      category: 'Ascali POS Application',
      description: 'Our fully managed Van Sale POS transforms mobile distribution into a high-efficiency operation via cloud-based web and mobile apps. Streamline on-field invoicing, real-time stock tracking, and route optimization effortlessly. Empower your drivers with offline transaction capabilities, instant digital receipts, and GPS-integrated delivery management, ensuring complete transparency and synchronized financial data from the road to your core ERP.',
      techStack: [
        'Sql Server',
        'C#',
        'MVC with Entity Framework',
        'AWS',
        'Flutter'

      ],
      features: [
        'On-the-Spot Invoicing',
        'Offline Mode',
        'Multi-Payment Support',
        'Route Optimization & GPS',
        'Visit Scheduling',
        'Van Inventory Management',
        'Dynamic Pricing & Discounts',
        'Credit Limit Alerts',
        'Stock Requisition',
        'End-of-Day Settlement',
        'ERP Integration'

      ],
      status: 'Live',
      image: '/api/placeholder/400/300',
      color: 'from-emerald-500 to-teal-500'
    }
  ];

  const getStatusBadge = (status) => {
    const statusConfig = {
      'Live': { bg: 'bg-green-100', text: 'text-green-800', dot: 'bg-green-500' },
      'Beta': { bg: 'bg-yellow-100', text: 'text-yellow-800', dot: 'bg-yellow-500' },
      'Coming Soon': { bg: 'bg-blue-100', text: 'text-blue-800', dot: 'bg-blue-500' },
      'Development': { bg: 'bg-purple-100', text: 'text-purple-800', dot: 'bg-purple-500' }
    };

    const config = statusConfig[status] || statusConfig['Development'];

    return (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${config.bg} ${config.text}`}>
        <div className={`w-2 h-2 rounded-full ${config.dot} mr-2`}></div>
        {status}
      </span>
    );
  };

  return (
    <section id="products" ref={sectionRef} className="w-full min-w-full bg-white">
      {/* Full-width background with proper padding */}
      <div className="w-full py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <div className={`text-center mb-16 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-6">
              Our <span className="gradient-text">Products</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-400 mx-auto mb-8"></div>
            <p className="text-lg md:text-lg text-slate-600 max-w-6xl mx-auto leading-relaxed text-left">
              We empower your business through
              <b>innovative, high-performance software</b> designed for modern challenges. Our suite features <b>intelligent automation, seamless cloud integration,</b> and<b> data-driven insights,</b> ensuring your operations remain agile. Experience scalable, secure, and user-centric solutions tailored to drive your digital evolution and growth.
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-8 lg:gap-10 items-stretch">
            {products.map((product, index) => (
              <div
                key={index}
                className={`group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden card-hover flex flex-col h-full ${isVisible ? 'animate-fadeInUp' : 'opacity-0'
                  }`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Product Header */}
                <div className={`h-48 bg-gradient-to-br ${product.color} relative overflow-hidden shrink-0`}>
                  <div className="absolute inset-0 bg-black/20"></div>
                  <div className="absolute top-4 right-4">
                    {getStatusBadge(product.status)}
                  </div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <div className="text-sm font-medium opacity-90 text-left">{product.category}</div>
                    <h3 className="text-2xl font-bold font-display text-left">{product.name}</h3>
                  </div>
                  {/* Decorative Elements */}
                  <div className="absolute -top-10 -right-10 w-32 h-32 bg-white/10 rounded-full"></div>
                  <div className="absolute -bottom-6 -left-6 w-20 h-20 bg-white/10 rounded-full"></div>
                </div>

                {/* Product Content */}
                <div className="p-8 flex flex-col flex-grow">
                  <p className="text-slate-600 text-[15px] leading-relaxed mb-8 text-left">
                    {product.description}
                  </p>

                  {/* Key Features */}
                  <div className="mb-8 flex-grow">
                    <h4 className="font-semibold text-slate-900 mb-4 text-sm uppercase tracking-wider text-blue-600">Key Features</h4>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-4">
                      {product.features.map((feature, featureIndex) => (
                        <div key={featureIndex} className="flex items-center text-sm text-slate-600">
                          <svg className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          {feature}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Tech Stack */}
                  <div className="mb-8">
                    <h4 className="font-semibold text-slate-900 mb-4 text-sm uppercase tracking-wider text-blue-600">Tech Stack</h4>
                    <div className="flex flex-wrap gap-2.5">
                      {product.techStack.map((tech, techIndex) => (
                        <span
                          key={techIndex}
                          className="px-3 py-1 bg-slate-100 text-slate-700 rounded-full text-sm font-medium"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex gap-4 mt-auto pt-6 border-t border-slate-100">
                    {product.status === 'Live' && (
                      <>
                        <button className="flex-1 bg-gradient-to-r from-blue-500 to-cyan-400 text-white py-3 px-4 rounded-lg font-semibold text-sm transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-200">
                          Live Demo
                        </button>
                        <button className="flex-1 border-2 border-slate-200 text-slate-700 py-3 px-4 rounded-lg font-semibold text-sm transition-all duration-300 hover:bg-slate-50 focus:outline-none focus:ring-4 focus:ring-slate-200">
                          Learn More
                        </button>
                      </>
                    )}
                    {product.status === 'Beta' && (
                      <>
                        <button className="flex-1 bg-gradient-to-r from-yellow-500 to-orange-400 text-white py-3 px-4 rounded-lg font-semibold text-sm transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-yellow-200">
                          Join Beta
                        </button>
                        <button className="flex-1 border-2 border-slate-200 text-slate-700 py-3 px-4 rounded-lg font-semibold text-sm transition-all duration-300 hover:bg-slate-50 focus:outline-none focus:ring-4 focus:ring-slate-200">
                          Learn More
                        </button>
                      </>
                    )}
                    {(product.status === 'Coming Soon' || product.status === 'Development') && (
                      <>
                        <button className="flex-1 bg-gradient-to-r from-purple-500 to-indigo-400 text-white py-3 px-4 rounded-lg font-semibold text-sm transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-purple-200">
                          Get Notified
                        </button>
                        <button className="flex-1 border-2 border-slate-200 text-slate-700 py-3 px-4 rounded-lg font-semibold text-sm transition-all duration-300 hover:bg-slate-50 focus:outline-none focus:ring-4 focus:ring-slate-200">
                          Learn More
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action - Full Width */}
      <div className="w-full bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 lg:pb-24">
          <div className={`text-center ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`} style={{ animationDelay: '0.8s' }}>
            <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-8 md:p-12 text-white">
              <h3 className="font-display text-3xl md:text-4xl font-semibold mb-6">
                Need a Custom Solution?
              </h3>
              <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
                Our products are just the beginning. We can create custom software solutions tailored to your specific
                business needs and requirements.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button className="bg-gradient-to-r from-blue-500 to-cyan-400 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-blue-200">
                  Discuss Your Project
                </button>
                <button className="bg-transparent border-2 border-white/30 text-white px-8 py-4 rounded-xl font-semibold text-lg backdrop-blur-sm transition-all duration-300 transform hover:scale-105 hover:bg-white/10 focus:outline-none focus:ring-4 focus:ring-white/30">
                  View All Services
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;